import { motion } from 'framer-motion';

/**
 * IndustriesGrid — reusable industries icon grid.
 *
 * Props:
 *  industries  {Array}   — array of { name, icon } objects
 *  className   {string}  — extra classes for the wrapping div
 */
export default function IndustriesGrid({ industries = [], className = '' }) {
  return (
    <div className={`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 ${className}`}>
      {industries.map((ind, i) => (
        <motion.div
          key={ind.name}
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: i * 0.05 }}
          whileHover={{ y: -3 }}
          className="card p-4 text-center"
        >
          <div className="text-4xl lg:text-6xl mb-2">{ind.icon}</div>
          <p className="text-sm lg:text-base font-medium" style={{ color: 'var(--color-text)' }}>{ind.name}</p>
        </motion.div>
      ))}
    </div>
  );
}
